import {
  Box,
  InputAdornment,
  TextField,
  Tooltip,
  Button,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  OutlinedInput,
  Checkbox,
  ListItemText,
  Chip,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useState } from 'react'
import { FormControlLabel } from '@material-ui/core'

const FinancialSearchBar = ({
  onChangeSearchBar,
  onChangeCheckBox,
  onChangeSelect,
  selectedUsers,
  managers,
  accountants,
  roleSearched,
  onlyCurrentUser,
}) => {
  const [searchString, setSearchString] = useState('')
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const handleChange = (event) => {
    const value = event.target.value

    if (value.length > 0 && value.length < 3) {
      setTooltipOpen(true)
    } else {
      setTooltipOpen(false)
    }

    setSearchString(value)

    // If search is empty, reset the table
    if (value.length === 0) {
      onChangeSearchBar(value)
    }
  }

  const handleSearch = () => {
    if (searchString.length >= 3 || searchString.length === 0) {
      onChangeSearchBar(searchString)
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  const handleChangeCheckBox = (event) => {
    onChangeCheckBox(event.target.checked)
  }

  return (
    <Box display="flex" style={{ position: 'relative' }} flexDirection="column">
      <Box display="flex" alignItems="center" marginBottom="16px">
        <Tooltip
          open={tooltipOpen}
          title="Minimum de 3 caractères"
          arrow
          placement="top"
        >
          <TextField
            sx={{ width: '500px' }}
            variant="outlined"
            placeholder={'Recherche par Copromatic Id ou Nom de copropriété'}
            value={searchString}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            size="small"
          />
        </Tooltip>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSearch}
          style={{ margin: '0 8px' }}
        >
          Rechercher
        </Button>
        <FormControlLabel
          control={
            <Checkbox
              checked={onlyCurrentUser}
              onChange={(e) => {
                handleChangeCheckBox(e)
              }}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
            />
          }
          label="Mes copropriétés"
        />
      </Box>
      <Box display="flex">
        <FormControl size="small">
          <InputLabel id="gestionnaire-select-label">Gestionnaire</InputLabel>
          <Select
            style={{ width: '250px', marginRight: '16px', padding: 0 }}
            multiple
            labelId="gestionnaire-select-label"
            value={
              roleSearched === 'Gestionnaire' && selectedUsers
                ? selectedUsers
                : []
            }
            onChange={(e) => onChangeSelect(e.target.value, 'Gestionnaire')}
            input={<OutlinedInput label="Gestionnaire" />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {selected.map((value) => (
                  <Chip key={value.id} label={value.fullName} />
                ))}
              </Box>
            )}
          >
            {managers.map((manager) => (
              <MenuItem key={manager.id} value={manager}>
                <Checkbox checked={selectedUsers.indexOf(manager) > -1} />
                <ListItemText primary={manager.fullName} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small">
          <InputLabel id="comptable-select-label">Comptable</InputLabel>
          <Select
            style={{ minWidth: '250px', maxWidth: '400px' }}
            labelId="comptable-select-label"
            multiple
            value={
              roleSearched === 'Comptable' && selectedUsers ? selectedUsers : []
            }
            onChange={(e) => onChangeSelect(e.target.value, 'Comptable')}
            input={<OutlinedInput label="Comptable" />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {selected.map((value) => (
                  <Chip key={value.id} label={value.fullName} />
                ))}
              </Box>
            )}
          >
            {accountants.map((accountant) => (
              <MenuItem key={accountant.id} value={accountant}>
                <Checkbox checked={selectedUsers.indexOf(accountant) > -1} />
                <ListItemText primary={accountant.fullName} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  )
}

export default FinancialSearchBar
